var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import Header from './header';
import Banner from './banner';
import About from './about';
import Activation from './activation';
import Installation from './installation';
import Faq from './faq';
import YourInstall from './yourinstall';
import Footer from './footer';
import ThankYou from './thankyou';
import { connect } from 'react-redux';
import Nav from './nav';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App(props) {
        return _super.call(this, props) || this;
    }
    App.prototype.render = function () {
        return (React.createElement(Router, null,
            React.createElement(Switch, null,
                React.createElement(Route, { path: "/activation" },
                    React.createElement(Header, null),
                    React.createElement(Activation, null)),
                React.createElement(Route, { path: "/thankyou" },
                    React.createElement(Header, null),
                    React.createElement(ThankYou, null)),
                React.createElement(Route, { path: "/" },
                    React.createElement(Header, null,
                        React.createElement(Nav, null)),
                    React.createElement(Banner, null),
                    React.createElement(About, null),
                    React.createElement(Installation, null),
                    React.createElement(Faq, null),
                    React.createElement(YourInstall, null),
                    React.createElement(Footer, null)))));
    };
    return App;
}(React.Component));
function mapStateToProps(state) {
    return { showNav: state.showNav };
}
export default connect(mapStateToProps)(App);
